var AbstractView = require("common/AbstractView");

/**
 * View for showing information about the app (version, logs etc.)
 *
 * @constructor
 * @extends {AbstractView}
 */
function AboutView() {
    var self = this;

    var $backButton = $('<a href="#" class="backButton" data-role="button" data-icon="mobile-back" data-iconpos="notext" data-inline="true">');
    $backButton.on("click", function() {
        self.publishEvent("NavigationManager", "go-back");
    });

    var $content = $(require("html!./about_view.html"));
    var $logView = $content.find("#logView");

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "About";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * Sets the content of the log view to the value specified
     *
     * @param {string} logContent - The content of the log to be displayed
     */
    this.setLogContent = function(logContent) {
        $logView.text(logContent);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
        var _height = Math.max(height - $logView.position().top - 40, 50) + "px";
        $logView.css("min-height", _height)
            .css("max-height", _height)
            .css("height", _height);

        $logView.scrollTop($logView[0].scrollHeight - $logView.height());
    };

    var super_show = this.show;
    this.show = function() {
        super_show.call(this);
        $logView.scrollTop($logView[0].scrollHeight - $logView.height());
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::about.title"),
            i18n : "common::about.title",
            leftButtons : [$backButton]
        };
    };

    this.setVersionLabel = function(label) {
        // Set the version label to show the app version and build
        $content.find("#versionLabel").text(label);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "fullscreen";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return false;
    };
}

AboutView.prototype = AbstractView;

module.exports = AboutView;